import services from './../../../services/service'; // Service Class
import ProductCartActions from './../../product/ProductCartActions.vue'
import ProductCTAActions from './../../product/ProductCTAActions.vue'
//
import Utility from './../../../resources/utility'; //Utility
//
import OrderCartView from './../CartWidget';
//
import {
    ADD_TO_CART,
    REMOVE_FROM_CART
} from '../../../store/mutation-types'
let service = new services();
export default {
    name: 'Product',
    props: ['product_data','productItem'],
    mixins: [Utility],
    data () {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            categories:{},
            main_category:{},
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sub_categories: [],
            product:{},
            details:{},
            reviews:{},
            information: {},
            states:{},
            cities:{},
            related_products:{},
            delivery_option:{},
            discount_coupon:{},
            product_item_group:{},
            product_item: {},
            sellpoint_categories:{},
            seller_mode:false,
            can_edit: false,
            edit_mode:false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option:false,
            edit_other_delivery_option:false,
            edit_city:false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel:false,
            editProductItemGroupPanel: false,
            removeItemGroupPanel:false,
            removeProductPanel:false,
            product_details_descr:true, //default view
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation:false,
            editDeliveryInformation:false,
            setProductDeliveryInformation:false,
            setDiscount:false,
            editDiscount:false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl:"",
            is_product_in_cart: false,
            loading:false,
            copied: false,
            descr_active: 'active',
            user_type:"buyer",
            new_added: false,
            product_display_image:{},
            action_loading: false,
            product_is_ready_to_cart:false,
            product_item_selected:[],
            product_item_group_selected:[],
            data_cart_message:"",
            data_cart_group_message:"",
            data_cart_item_message:"",
            product_set_shipping_fee_status:12,
            set_shipping_fee_status_track:false,
            check_order_quantity:"",

            //
            product_addon: {},
            product_addon_item:{},
            product_addon_item_group:{},

            //
            tab_view: {},
            menu_tab_inner_view:{},
            product_item_quantity_key:0,
            share_url:"",
            share_text:"",
            related_products:"",
            product_ref_link: "",

            //keys
            setproductAddonKey:0,

            //cta-actions
            cta_add_to_cart:1,//add to cart
            cta_buy_now:2, //order-buy-now
            cta_donate_to_buy:3, //donate-to-buy

            //component-sets
            product_component: [1,"product","set-product","PR",],
            product_item_component: [2,"product_item", "product-item", "PRT"],
            product_item_group_component: [3,"product_item_group", "product-item-group", "PRTG"],
            product_addon_component: [4,"product_addon", "product-addon", "PRAD"],
            product_addon_item_component: [5,"product_addon_item", "product-addon-item", "PRADT"],
            product_addon_item_group_component: [6,"product_addon_Item_group", "product-addon-item-group", "PRADTG"],
        
            //
            ctaType:2, //buy now default
            productMain:{},
            productItemGroup:{},
            // productItem:{},
            productMainView:{},
            //--
            set_ctaType:2, //buy now default
            set_productMain:{},
            set_productItemGroup:{},
            set_productItem:{},
            set_productMainView:{},
            cart: this.$store.state.cart,

            //
            set_xview:false,
        }
    },
    components: {
        'add-to-cart-button': ProductCartActions,
        'product-cta-button': ProductCTAActions,
        'xview-order': OrderCartView,
    },
    computed:{
        canAdd () {
            // return this.cart.indexOf(this.set_productItem) < 0
            const index = this.cart.findIndex(p => p.product_item_id === this.set_productItem.product_item_id) //best removal
            if(index < 0){
              return true;
            }
        }
    },
    
    methods: {
        redir(rlink){
            location.replace("/"+rlink)
        },
        copyLinkXX() {
            this.$clipboard(this.siteUrl)
            this.copied = true;
        },
        copyLink(link,id) {
            this.$clipboard(link);
            this.copied = true;
            document.getElementById(id).style.display = "block";
        },
        numFormat(str){
            // console.log(str.toString().replace(/[\$,]/g, ''));
            // return Number(str.toString().replace(/[\$,]/g, ''));
            // console.log(str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"));

            return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        },
        mobileSideNavToggle(action){
            if(action == "open"){
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if(action == "close"){
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        setMenuTabInnerView(view,attr1,attr2){
            this.setComponent('reset-edit','');
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;
        },
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        openModal(id) {
            document.getElementById(id).style.display = "block";
        },

        closeModal(id) {
            document.getElementById(id).style.display = "none";
        },

        setAddToWishlist(item){
            //set_wishlist
            this.wishlist_product = item;
            this.addToWishlist();
        },
        
        addQuantity(qty){
            if(this.product_item.product_item_order_quantity == undefined){
                this.product_item.product_item_order_quantity = 1;
            }else{
                this.product_item.product_item_order_quantity++
            }
            this.product_item_quantity_key++;
            this.checkOrderQuantity(qty);
        },

        removeQuantity(qty){
            if(this.product_item.product_item_order_quantity != 1){
                this.product_item.product_item_order_quantity--;
                this.product_item_quantity_key++;
                this.checkOrderQuantity(qty);
            }
        },

        checkOrderQuantity(qty){
            if((this.product_item_selected.product_item_price > 0) && (this.product_item.product_item_order_quantity != 0))
            {
                if(Number(qty) > this.product_item.product_item_quantity){
                    this.check_order_quantity = "The quantity you entered is above Item Quantity";
                    this.product_is_ready_to_cart = false;
                    this.data_cart_message = "The quantity you entered is above Item Quantity";
                }else{
                    //NEW//check wholesale options
                    this.checkWholesalePrices();
                    //check and calculate discounts
                    //--MOVED--TO--WHOLESALE--CALL--//this.checkDiscountsByQuantity();
                    this.check_order_quantity = "";
                    this.product_is_ready_to_cart = true;
                    this.data_cart_message = "";
                }
            }else{
                this.check_order_quantity = "";
            }
        },

        checkWholesalePrices(){
            if(this.product.product_has_wholesale_options){
                //refresh
                if(this.product_item.product_item_actual_mapped_price != 0){
                    this.product_item.product_item_price = this.product_item.product_item_actual_mapped_price;
                }
                //loop through this product item moqs
                let checked_moqs = []; //for picking checked array 
                for(let moq of this.product_item.product_item_moqs) {
                    //if quantity matches with the moq
                    if(!(checked_moqs.includes(moq.product_item_moq_id))){
                        if(Number(Number(this.product_item.product_item_order_quantity) >= moq.product_item_moq)){
                            //assign the matching price
                            this.product_item.product_item_price = moq.product_item_moq_price;
                            this.product_item.product_item_price_f = this.numFormat(this.product_item.product_item_price);
                        }
                    }
                    checked_moqs.push(moq.product_item_moq_id);
                }
                //check and calculate discounts
                this.checkDiscountsByQuantity(); //CALL HERE
            }
        },

        checkDiscountsByQuantity(){
           //refresh
            this.product_item.product_item_total_discount = 0;
            if(this.product_item.product_item_actual_price != 0){
                this.product_item.product_item_price = this.product_item.product_item_actual_price;
            }
            //.//refresh
            let total_discount = 0; let calc_discount = 0; let product_item_discount_price = 0;
            // get quantities that match
            for(let dc of this.product_item.product_item_discounts) {
                if(Number(Number(this.product_item.product_item_order_quantity) >= dc['discount_min_quantity'])){
                    if((dc['discount_status_id'] == 5) && (dc['discount_coupon'] == 'D')){ //active - not expired
                        total_discount += Number(Number(dc['discount_percentage']));
                    }
                }
            }
            if(total_discount != 0){
                this.product_item.product_item_actual_price = this.product_item.product_item_price; //store first
                
                //calc product_actual_price and product_item_discount_price
                calc_discount = ((total_discount/100) * this.product_item.product_item_price);
                product_item_discount_price = (this.product_item.product_item_price - calc_discount);
                this.product_item.product_item_total_discount = total_discount;
                this.product_item.product_item_price = product_item_discount_price;
                this.product_item.product_item_price_f = this.numFormat(product_item_discount_price)
                // $total_product_item_discounted += 1;
            }else{
                this.product_item.product_item_price_f = this.numFormat(this.product_item.product_item_price)
            }
        },

        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
              this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = true; //check
            }
        },

        setTabComponent(view){
            this.tab_view = {};
            this.tab_view[view] =  true;
        },
        
        setComponent(attr1,attr2,component_set){
            // this.action_loading = true;
            this.setPanel = true;
            if(attr1 == 'edit-product'){
                this.editProductPanel = true;
            }
            if(attr1 == 'remove-product'){
                this.removeProductPanel = true;
            }
            if(attr1 == 'add-product-item'){
                this.addProductItemPanel = true;
            }
            if(attr1 == 'edit-product-item'){
                this.editProductItemPanel = true;
            }
            if(attr1 == 'set-edit-product-item'){
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if(attr1 == 'remove-product-item'){
                this.product_item = attr2;
                this.removeItemPanel = true;
            }
            if(attr1 == 'edit-product-item_group'){
                this.product_item_group = attr2;
                this.editProductItemGroupPanel = true;
            }
            if(attr1 == 'remove-product-item_group'){
                this.product_item_group = attr2;
                this.removeItemGroupPanel = true;
            }
            if(attr1 == 'set-product-item-group-image'){
                //using kmodular
                this.setProductItemGroupImage(attr1,attr2,component_set);
                // this.product_item_group.product_item_group_image = attr2;
                // var imgs = document.getElementsByClassName('product-item-group-image');
                // for (var i = 0; i < imgs.length; i++) {
                //     imgs[i].style = "border:none;";
                // //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
                // } 
                // document.getElementById(attr2+"PRTG").style.border = "1px solid #0000CC";
            }
            if(attr1 == 'edit-product-detail'){
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if(attr1 == 'edit-product-delivery'){
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if(attr1 == 'add-delivery-option'){
                this.addDeliveryInformation = true;
            }
            if(attr1 == 'set-product-delivery-option'){
                this.delivery_option.edit_set = false;
                this.setProductDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
            }
            if(attr1 == 'set-product-item'){
                this.check_order_quantity = "";
                this.data_cart_message = ''; 

                this.product_item = attr2;
                this.product_item_selected = attr2;

                //styling to show selected active group
                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                } 
               
                //don't apply if product item size or service group or any product item specific attr is not available
                if((attr2.product_item_size != "Nill") && (attr2.product_item_size != "")){
                    document.getElementById(attr2.product_item_id+"PRT").style= "border:1px solid #0000CC;";
                }
                
                //some settings
                this.data_cart_item_message = '';
                this.data_cart_message = ''; //recheck
                this.prep_set_product_is_ready_to_cart();
            }
            if(attr1 == 'set-product-item-group'){
                this.check_order_quantity = "";
                this.data_cart_message = '';  

                this.product_item_group = attr2;
                this.product_item_group_selected = attr2;

                //set display image
                this.product_display_image = [];
                this.product_display_image.product_image = attr2.product_item_group_image;

                ///resets
                //first--reset ready to cart
                this.product_is_ready_to_cart = false;
                this.product_item_selected = []
                //second--remove styling for product items
                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                } 
                ////...resets

                //then style to show selected active group
                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    // grps[i].style = "border:none;"; //REMOVED COS IT REMOVES ALL STYES ESP. BACKGROUD COLOR
                    grps[i].style.border = "none";
                    // grps[i].classList.add('sp-remove-active-border-color')
                } 

                // document.getElementById(attr2.product_item_group_id+"PRTGR").style= "border:1px solid #0000CC;";
                document.getElementById(attr2.product_item_group_id+"PRTGR").style.border = "1px solid #0000CC";

                //some settings
                this.data_cart_group_message = '';
                //if this group does not have size entered, then auto activate its product item so that you would not select size
                if((attr2.product_items[0].product_item_size == "Nill") || (attr2.product_items[0].product_item_size == "")){
                    //auto activate
                    this.setComponent('set-product-item',attr2.product_items[0]);
                }
                else{
                    if(this.product.product_service == 'P'){
                        // this.data_cart_item_message = "please select a Size";
                        this.data_cart_item_message = "please select";
                    }else{
                        // this.data_cart_item_message = "please select a Service item";
                        this.data_cart_item_message = "please select";
                    } 
                }
            }
            if(attr1 == 'set-product-display-image'){
                this.product_display_image = attr2;
            }
            if(attr1 == 'set-descr'){
               // console.log(location.href);
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails',''));
               // location.replace(location.href.replace('#productDetails',''))
                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if(attr1 == 'set-reviews'){
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails','')); //refresh url to allow next click
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if(attr1 == 'set-information'){
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if(attr1 == 'set-discount'){
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if(attr1 == 'edit-discount'){
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if(attr1 == 'reset-edit'){
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.editProductItemGroupPanel = false;
                this.removeItemGroupPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false
            }
            let self = this;

            setTimeout(function(){ self.action_loading = false; }, 2000); //wait for 3sec and turn off loading
            // this.action_loading = false;
        
        },

        setComponentActions(attr1,attr2){
            if(attr1 == 'reset-edit'){
                this.details = {};
            }
            
        },

        preset() {
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.is_editing();
                    self.sellpoint.business_id = self.product.product_business_id;
                    self.loggedIn = true;
                    self.loading = false;
                }else {
                   // self.$router.push('login');
                   self.loading = false;
                }
            });
        },
    

        is_editing(){ //preseting if seller
            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            }
            service.can_edit(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.seller_mode = true;  //important
                    this.edit_mode =  true;
                    this.can_edit = true;
                }else {
                    this.edit_mode =  false;
                    this.seller_mode = false;  //important
                }
            }).catch((err) => {
                if(err) {
                    //log error
                }
            })
        },

        switchMode(){
            if(this.edit_mode == false){
                this.is_editing(); //revalidate seller
            }else{
                this.edit_mode = false;
                this.can_edit = true;
            }
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state,option){
            if(option == "edit"){this.edit_city = true;}
            else{this.edit_city = false}
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    this.cities = response.body.data;
                }
            }).catch((err) => {})
        },

        setOtherOptions(v,o){
            if(v != undefined){
                if(v == "other"){
                    this.other_delivery_option = true;
                    if(o == "edit"){this.edit_other_delivery_option = true;}//for edit
                }
                if(v == "all"){
                    this.delivery_option.business_delivery_other_option = "nill";
                    if(o == "edit"){this.edit_other_delivery_option = false;}//for edit
                    this.other_delivery_option = false;
                }
            }
        },

        set_data_messages(data,action){
            if(this.product.product_service == 'P'){
                if(action == 'set'){
                    if(data == 'product-item'){

                    }
                }
                if(action == 'unset'){
                
                }
            }else{

            }
        },

        prep_set_product_is_ready_to_cart(){
            if(this.product_item_selected.length != 0){
                this.product_is_ready_to_cart = true;
            }else{
                this.data_cart_message = "make a selection before you proceed";
                if(this.product_item_group_selected.length != 0){ //check group first
                    if(this.product.product_service == 'P'){
                        // this.data_cart_item_message = "please select a Size";
                        this.data_cart_item_message = "please select";
                    }else{
                        // this.data_cart_item_message = "please select a Service item";
                        this.data_cart_item_message = "please select";
                    } 
                }else{ //group not yet selected
                    if(this.product.product_service == 'P'){
                        // this.data_cart_group_message = "please select Colour";
                        this.data_cart_group_message = "please select";
                    }else{
                        // this.data_cart_group_message = "please select a Service Package";
                        this.data_cart_group_message = "please select";
                    } 
                }
            }
        },

        isEmpty(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        },

        

        set_product_is_ready_to_cart(){
            //first checkpoint on product load
            //check if product has only one group and group has only one item
            // if check then set product_is_ready_to_cart as true

            // if(this.product_item_group.length <= 1){   //merged in AND below
                //check items
                // if(this.product_item.length <= 1){
                if((this.product.product_set_groups <= 1) && (this.product.product_set_items <= 1)){ 
                    //can-add
                    //some settings
                    this.product_item_selected = this.product_item; //item
                    this.product_item_group_selected = this.product_item_group; //group
                    this.product_is_ready_to_cart =  true;
                }
            // }
            //else leave as false
        },

        setProduct(){ 
            this.loading = true;
            // service.getProductSearch(this, this.$route.params.id1).then(response => {
            service.getProductSearch(this, this.product_data.product_url_name).then(response => {
                if(response.body.status == 200) {
                    this.product = response.body.data;
                    this.setProductRelationships();
                    document.title = this.product.product_name + " | " +this.product.product_business_name+ " | SP";
                    //set display image
                    if(Object.keys(this.product.product_images).length > 0){
                        this.product_display_image = this.product.product_images[0];
                    }else{
                        this.product_display_image.product_image = "";
                    }
                    this.product_item = this.product.product_items[0];
                    if(this.product.product_item_groups.length != 0){
                        this.product_item_group = this.product.product_item_groups[0];
                    }else{
                        this.product_item_group = [];
                    }

                    this.product_set_shipping_fee_status = this.product.product_set_shipping_fee_status;
                   
                    //set for prep selected addons
                    this.product.selected_product_addons = [];
                    
                    //set product_is_ready_to_cart
                    this.set_product_is_ready_to_cart();
                    
                    this.siteUrl = service.siteUrl+"?p="+this.product.product_url_name
                    +"&p1="+this.product.product_business_ownername
                    +"&p2="+this.product.product_url_name
                    +"&p3="+encodeURI(this.product.product_name)
                    +"&p4="+encodeURI(this.product.product_description)
                    +"&p5="+this.product_item.product_item_image
                    +" ";
            
                    this.product.product_share_url = "http://sellpoints.com.ng/"+this.product.product_business_ownername+"/"+this.product.product_url_name;
                    this.loading = false;
                    //
                    this.preset();
                    
                    //set other products
                    this.setRelatedProducts(this.product.product_business_id);
                    //new-get new categories
                    this.getCategories(this.product.product_business_category_id);
                    //set sellpoint categories
                    this.getSellpointCategories();
                    //check if already added to cart
                    this.check_in_cart()
                    // this.loading = false;

                    this.setPrepOrderNow();
                }
            }).catch((err) => {
                // console.log(err)
             //   this.redir(this.$route.params.id1); //go to sellpoint
                //log it
                //location.replace("/")
            })
        },

        //props converted settings for temp ordernow syncs
        setPrepOrderNow(){
            ///...
            //PREVS-PROPS-HANDLES//::-> :ctaType="cta_buy_now" :productMain="product" :productItemGroup="product_item_group" :productItem="product_item"
            //settings
            //--set get props //to avoid using it directly thereby preserving it
            this.set_ctaType = this.ctaType;
            this.set_productMain = this.product;
            this.set_productItemGroup = this.product_item_group;
            this.set_productItem = this.product_item
            this.set_productMainView = this.productMainView;
            //---setting props
            if(this.set_ctaType == 2){ //buy-now
                if(this.set_productMain.product_cta_name && (this.set_productMain.product_cta_name == 'error')){
                this.set_productMain.product_cta_name = "Buy Now";
                }
            }
            //
            this.set_productMain.product_cta_name = "Place Order";
            
            ///....
        },

        setProductAddOn(product_addon){
            this.product_addon = product_addon;
            this.product_addon.selected = false;
            this.product_addon_item = product_addon.product_items[0];
            this.product_addon_item_group = product_addon.product_item_groups[0];
        },
        

        setSelectedProductAddOns(){
            let set_product_addon = [];
            //check if exists
            let added = false;
            if(Object.keys(this.product.selected_product_addons).length > 0){
                for(let addon of this.product.product_selected_product_addons){
                    if(addon.product_id == this.product_addon.product_id){
                        added = true;
                    }
                }
            }
            if(!added){
                this.product_addon.selected = true;
                this.product_addon.product_order_addon_to = this.product.product_id; //this main product
                //prepare cart settings
                set_product_addon.productMain = this.product_addon;
                set_product_addon.productItemGroup = this.product_addon_item_group; //as set during addon for add to cart
                set_product_addon.productItem = this.product_addon_item;
                //push
                this.product.selected_product_addons.push(set_product_addon);
            }
            this.setproductAddonKey++;
            //--add if does not exists
        },

        removeFromProductAddOns(){},

        setProductRelationships(){
            //check_1 - //for referrals
            localStorage.removeItem("REF-"+this.product.product_url_name);//refresh
            if(this.$route.params.ref0){
                localStorage.setItem("REF-"+this.product.product_url_name,this.$route.params.ref0);
                // this.product.product_current_ref_bash = this.$route.params.ref0;
            }
            //check-2- if agent is selling this product
            var payload = {
                product: this.product.product_id,
                business: this.product.product_business_id,
                business_agent_username: this.$route.params.id,
            }
            service.setProductAgentShip(this, payload).then(response => {
                if(response.body.status == 200){
                    this.product.product_agent_ship = response.body.data_product_agent_ship;
                }
            }).catch((err) => {})
            //.../check-2-
        },

        setProductViewOptions(component_set,attr){
            //settings
            //--Type--Product(10),ProductItem(11),ProductItemGroup(12),ProductAddon(20),ProductAddonItem(21),ProductAddonItemGroup(22)
            // let type_name = 0; let type_pre = ""; let style_id = ""; let style_class = "";
            // if(type == 1){
            //     type_name = "Product"; type_pre = "product"; style_id="PR";
            // }
            let type = component_set[0];
            if(type == 1){
                this.product = attr;
            }else if(type == 1){
                this.product = attr;
            }


        },

        setProductItemGroupImage(attr1,attr2,component_set){ //kmodularise
            attr1.product_item_group_image = attr2;
            var imgs = document.getElementsByClassName('product-item-group-image');
            for (var i = 0; i < imgs.length; i++) {
                imgs[i].style = "border:none;";
                //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
            } 
            document.getElementById(attr2+"PRTG").style.border = "1px solid #0000CC";
            //SET COMPONENT
            this.setProductViewOptions(component_set,attr1);
        },

        getCategories(category){
            service.getMainCategories(this, category).then(response => {
               if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
        },

        getSubCategories(category){
            if(category != undefined){
                this.sub_categories = category.sub_categories;
            }else{
                this.sub_categories = [];
            }
        },


        check_in_cart(){
            this.cart.forEach(function(element) {
                if(element.product_item_id == this.product_item.product_item_id)
                {
                   this.is_product_in_cart = true;
                }
            }, this);
        },

        numFormat(str){
            return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        },

        setProductCustomPrice(){
            if(this.product_item.product_item_order_custom_set_price > 0){
                //calc discount
                let total_discount = this.product_item.product_item_total_discount;
                if(total_discount > 0){
                    let calc_discount = 0;
                    calc_discount = ((total_discount/100) * this.product_item.product_item_order_custom_set_price);
                    //assign new product item price
                    this.product_item.product_item_price = (this.product_item.product_item_order_custom_set_price - (calc_discount));
                }else{
                    this.product_item.product_item_price = this.product_item.product_item_order_custom_set_price;//assign new product item price
                }
                //do formating
                this.product_item.product_item_price_f = this.numFormat(this.product_item.product_item_price);
                //some custom setttings
                this.product_item.product_item_order_custom_set_price_type = 36; //gift-card-set
            }
        },
        
        setRelatedProducts(){
            var payload = {
                business:this.product.product_business_id,
                category:this.product.product_category_id,
                product:this.product.product_id,
                limit:4,
                user_search:[],
            }
            service.setRelatedProducts(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.related_products = response.body.data;
                }
            }).catch((err) => {})
        },

        //other product settings
        setReferralBash(){
            let set_ref_for = this.product.product_business_id; //default
            if(this.product.product_agent_ship.product_business_agent_id > 0){ //if agent is selling
                if(this.product.product_agent_ship.product_business_agent_type == 20){ //advanced agent
                  set_ref_for = this.product.product_agent_ship.product_business_agent_id;
                }
            }
            var payload = {
                ref_user: this.user.user_id,
                ref_of_type: 17,//product-referral
                ref_of: this.product.product_id,
                ref_for: set_ref_for,
            }
            service.setReferralBash(this, payload).then(response => {
                // if(response.body.status == 200) {
                    let product_ref_bash = response.body.data_ref_bash;
                    if(product_ref_bash && (product_ref_bash != "")){
                        this.product_ref_link = service.app_url+this.$route.params.id+"/"+this.product.product_url_name+"/"+product_ref_bash;
                    }
                    console.log(this.product_ref_link)
                //}
            }).catch((err) => {})
        },

        //images
        getProductImages(){
            service.getProductImages(this,this.product.product_id).then(response => {
                if(response.body.status == 200) {
                    this.product.product_images = response.body.data;
                    this.product_display_image = this.product.product_images[0];
                }
            }).catch((err) => {})
                
        },

        deleteProductImage(image){
            service.deleteProductImage(this, image).then(function(data) {
                if(data.body.status == 200) {
                    this.getProductImages();
                }
            }).catch((err) => {})
        },
        //images
        //edit product
        editProduct(){
            this.activate_processing();
            //this.business.agree = true;
            //some settings
            let set_product_category = this.product.product_category_id;
            if((this.product.product_sub_category != undefined) || (this.product.product_listed_category != undefined)){ //if either of 2 where selected
                set_product_category = 0; //make product_category 0
            }else{
                if(this.product.product_category != undefined){ //if new product_category is selected
                    set_product_category = this.product.product_category;
                }else{
                    set_product_category = this.product.product_category_id; //current product_category
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,
                // product_category: this.product.product_category || this.product.product_category_id, //before

                //new
                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                //

                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id, //new to help with category settings
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        //toastr.success("Product Updated", 'Success!');
                        this.editProductPanel = false;
                        this.product = response.body.data;
                        navi.push("/"+this.product.product_business_ownername+"/"+this.product.product_url_name);
                    }else{
                        this.editProductPanel = false;
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {
                        //toastr.warning("Something went wrong", 'Warning!'); 
                        this.editProductPanel = false; //manage with this for now
                        this.deactivate_processing();
                    }
                })
            }else {
               // toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        //edit product item
        editProductItem(){
            this.activate_processing();
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                product_item_price: this.product_item.product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 1
            }
    
            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.product_item = response.body.data;
                        this.deactivate_processing();
                        this.editProductItemPanel = false;
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.deactivate_processing();
                }
        },

        //edit product item group
        editProductItemGroup(){
            this.activate_processing();
            let product_item_group_is_color_image = 'IMG';
            if(this.product_item_group.product_item_group_color == undefined){
                product_item_group_is_color_image = 'IMG';
            }else{
                product_item_group_is_color_image = 'COL';
            }

            //set only color if defined
            if(this.product_item_group.product_item_group_color_new != undefined){
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new; //a new one
                this.product_item_group.product_item_group_image = 0; //set image to 0
            }else{
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill"; //set color to nill
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0,
            }


           let navi = this.$router;
            if(credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        //this.product_item_group = response.body.data;

                        this.product.product_item_groups = response.body.data;

                        this.deactivate_processing();
                        this.editProductItemGroupPanel = false;
                    }else{
                        this.deactivate_processing();
                        this.editProductItemGroupPanel = false;
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.deactivate_processing();
                }
        },

        removeProduct(){
            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id
            }
            let navi = this.$router;
            service.removeProduct(this,this.product.product_id,payload).then(response => {
                if(response.body.status == 200) {
                    this.redir(this.$route.params.id1); //go to sellpoint
                    
                    this.removeProductPanel = false;
                }
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    this.disable_btn = false;
                    this.redir(this.$route.params.id1); //go to sellpoint
                }
            })
            
        },

        removeProductItem(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            }
            let navi = this.$router;
            service.removeProductItem(this,this.product_item.product_item_id,payload).then(response => {
                if(response.body.status == 200) {
                    if(response.body.no_product){
                        this.redir(this.$route.params.id); //go to sellpoint
                    }
                    this.product.product_item_groups = response.body.data;
                   // location.reload(true)
                    //this.product.product_item = response.body.data;
                    //maually delete from array
                    //product_item_group.product_items.splice(this.product_item.product_item_id, 1 );
                    this.deactivate_processing();
                    this.removeItemPanel = false;
                }
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    this.deactivate_processing();
                }
            })
            
        },

        removeProductItemGroup(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            }
            let navi = this.$router;
            service.removeProductItemGroup(this,this.product_item_group.product_item_group_id,payload).then(response => {
                if(response.body.status == 200) {
                    if(response.body.no_product){
                        this.redir(this.$route.params.id); //go to sellpoint
                    }
                    this.product.product_item_groups = response.body.data;
                    this.deactivate_processing();
                    this.removeItemGroupPanel = false;
                }
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    this.deactivate_processing();
                }
            })
            
        },


        addProductDetail(){
            this.activate_processing();
            var payload = {
                product_detail: this.details.new_product_detail || "nill",
                product_id: this.product.product_id
            }
            service.addProductDetail(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    //toastr.success("Product Detail Added", 'Ok!');
                    this.product.product_details = data.body.data;
                    this.details = {};
                    this.deactivate_processing();
                }else{
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
                this.details = {};
                this.deactivate_processing();
            })
        },
    
        editProductDetail(){
            this.details.product_id = this.product.product_id;
            service.editProductDetail(this, 1, this.details).then(function(data) {
                if(data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch((err) => {
                //log it
                this.service = {};
            })
        },

        deleteProductDetail(details){
            var payload={
               product_detail_id: details.product_detail_id
            }
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch((err) => {
                //log it
                this.service = {};
            })
        },

        
        setProductDelivery(){
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            }
            service.setProductDelivery(this, 1, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.details = {}
                   // this.product.product_delivery_details = this.product.product_delivery;
                    this.details.edit_product_delivery = false;
                }
            }).catch((err) => {
                //log it
            })
        },

        setProductShippingFeeStatus(){
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status,
            }
            service.setProductShippingFeeStatus(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                }
            }).catch((err) => { 
                //log it
            })
        },

        //commwnta,reviews
        addProductReview(){
            var payload = {
                product_reviewed_by: this.user.user_id || 1,
                product_review: this.reviews.review || "nill",
                product_id: this.product.product_id
            }
            service.addProductReview(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    //toastr.success("Product Detail Added", 'Ok!');
                    // console.log(data.body.data)
                    this.product.product_reviews = data.body.data;
                    this.reviews = {};
                }
            }).catch((err) => {
                //log it
                this.reviews = {};
            })
        },

        //more information
        getProductInformation(){
            service.getProductInformation(this,this.product.product_id).then(response => {
                if(response.body.status == 200) {
                    this.product.product_information = response.body.data;
                }
            }).catch((err) => {})
                
        },
        addProductInformation(){
            var payload = {
                product_info_detail: this.information.product_info_detail || "nill",
                product_info_type: "text",
                product_id: this.product.product_id
            }
            if(payload.product_information != "nill"){
                service.addProductInformation(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        //toastr.success("Product Detail Added", 'Ok!');
                        this.product.product_information = data.body.data;
                        this.information = {};
                    }
                }).catch((err) => {
                    //log it
                    this.details = {};
                })
            }
        },
    
        editProductInformation(){
            this.details.product_id = this.product.product_id;
            service.editProductInformation(this, 1, this.details).then(function(data) {
                if(data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch((err) => {
                //log it
                this.service = {};
            })
        },

        deleteProductInformation(details){
            var payload={
               product_detail_id: details.product_detail_id
            }
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch((err) => {
                //log it
                this.service = {};
            })
        },

        //delivery options
        //new
        setProductDeliveryOption(){
            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            }
            if(payload.business_product_delivery_option_price == 0){
                toastr.warning("Delivery Charge not Added", 'Warning!');
            }else{
                if((payload.business_product_delivery_option != 0)){
                    service.setProductDeliveryOption(this, payload).then(function(data) {
                    if((data.body.status == 200) || (data.body.status == 201)) {
                       // toastr.success("Sellpoint Delivery Details edited",'Success!');
                        // this.product.product_delivery_options = data.body.data;
                        this.product.product_business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.setProductDeliveryInformation = false;
                        //this.delivery_option = {};
                        this.deactivate_processing();
                    }else{
                        this.deactivate_processing();
                    }
                    }).catch((err) => {
                        //log it
                        //this.delivery_option = {};
                        this.delivery_option.edit_set = false;
                        this.setProductDeliveryInformation = false;
                        this.deactivate_processing();
                    })
                }else{
                    //toastr.warning("Select a delivery option", 'Warning!');
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryFee(id){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
            }
            service.deleteDeliveryOption(this, id, payload).then(function(data) {
                if(data.body.status == 200) {
                    //toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch((err) => {
                //log it
                this.delivery_option = {};
            })
        },
        //.//new
        addDeliveryOption(){
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_product: this.product.product_id,
                business_id: this.sellpoint.business_id
            }
            if(payload.business_delivery_option_price == 0){
                toastr.warning("Delivery Charge not Added", 'Warning!');
            }else{
                if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                    service.addDeliveryOption(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            //toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch((err) => {
                        //log it
                        this.delivery_option = {};
                    })
                }else{
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
            
        },
    
        editDeliveryOption(){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            }
            //this.delivery_option.business_id = this.sellpoint.business_id;
            if(payload.business_delivery_option_price == 0){
                toastr.warning("Delivery Charge not Added", 'Warning!');
            }else{
                if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                    service.editDeliveryOption(this, payload).then(function(data) {
                    if(data.body.status == 200) {
                       // toastr.success("Sellpoint Delivery Details edited",'Success!');
                        this.product.product_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.editDeliveryInformation = false;
                        //this.delivery_option = {};
                    }
                    }).catch((err) => {
                        //log it
                        //this.delivery_option = {};
                        this.delivery_option.edit_set = false;
                        this.editDeliveryInformation = false;
                    })
                }else{
                    //toastr.warning("Select a delivery option", 'Warning!');
                    
                }
            }
        },
    
        deleteDeliveryOption(id){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
            }
            service.deleteDeliveryOption(this, id, payload).then(function(data) {
                if(data.body.status == 200) {
                    //toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch((err) => {
                //log it
                this.delivery_option = {};
            })
        },

        //./delivery option

        //set coupons and discount
        setDiscountsAndCoupons(){
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: this.product_item.product_item_id,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D', //or coupon
                coupon_business_category:0,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date,
            }
            service.setDiscountsAndCoupons(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setDiscount = false;
                }
            }).catch((err) => {
                //log it
            })
        },

        // edit coupons and discount
        editDiscountsAndCoupons(){
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function(data) {
                if(data.body.status == 200) {
                    //toastr.success("Discount Set", 'Update!');
                    //this.product_item.product_item_discounts = data.body.data;
                    this.editDiscount = false;
                }
            }).catch((err) => {
                //log it
            })
        },

        
        // edit coupons and discount
        deactivateDiscountsAndCoupons(payload){
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    payload.discount_status_id = 6; //temp setting

                   // toastr.success("Discount Set", 'Update!');
                  //  this.product_item.product_item_discounts = data.body.data;
                    //this.setComponentActions('reset-discount-coupon','');
                }
            }).catch((err) => {
                //log it
            })
        },

        //uploads
        onFileChange(e,type,data_id) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                // formData.append('data_id', this.product_item.product_item_id);
                // formData.append('data_type', "product_items");   

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        // if(type == "product_item"){
                        //     this.product_item.product_item_image = data.body.data;
                        // }
                        if(type == "products"){
                            this.getProductImages();
                            if(this.editProductItemGroupPanel){ //ie product_item_group edit going on
                                this.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }
                        
                        if(type == "product_information"){
                            this.getProductInformation();
                        }
                    }
                }).catch((err) => {
                    if(err) {
                        // log it
                    }
                })
            }   
                
        },

        
        //-- /.other product settings

        //categories settings
        getSellpointCategories(){
            service.getBusinessByUserName(this, this.product.product_business_ownername).then(response => {
                if(response.body.status == 200) {
                   let sellpoint = response.body.data;
                   service.getBusinessCategories(this, sellpoint.business_id).then(response => {
                        if(response.body.status == 200) {
                            this.sellpoint_categories = response.body.data;
                        }
                    }).catch((err) => {})
                }
            }).catch((err) => {
                //log it
               // this.$router.push("/")
               //console.log(err)
            })

        },

        //--./categories settings 
        handleScrollFix (event) {
            // Any code to be executed when the window is scrolled
           var x = document.getElementById("menuHeader");
           // device detection
           var isMobile = false;
           if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
           || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
           isMobile = true;
           }
           if(isMobile){
        //    if ($(window).scrollTop() >= 300) {
                if (document.documentElement.scrollTop >= 300) {
                    x.style.display = "block"; //mobile sort and filters
            }
            else {
                x.style.display = "none";
            }
           }
           
         },

        /////
        addToCart () {
            //settings
    
            //--if active order eg buy now
            if(this.set_ctaType == 2){
              this.set_productItem.active_order = true;
              this.set_productItem.product_buy_now_ref = 'qx-r'; //some sett
            }
            //---//
    
            //--prepare set_productItem for adding to cart
            this.set_productItem._id = this.set_productItem.product_item_id;
            //config qty if not set
            if(this.set_productItem.product_item_order_quantity == undefined){
              this.set_productItem.product_item_order_quantity = 1;
            }
            this.set_productItem.product_main_id = this.set_productMain.product_id;
            this.set_productItem.product_business_name = this.set_productMain.product_business_name;
            this.set_productItem.product_business = this.set_productMain.product_business_ownername;
            this.set_productItem.product_name = this.set_productMain.product_name;
            this.set_productItem.product_url = this.set_productMain.product_business_ownername+"/"+this.set_productMain.product_url_name;
            this.set_productItem.product_item_quantity = this.set_productItem.product_item_quantity;
            this.set_productItem.product_item_need_shipping = this.set_productMain.product_need_shipping;
            //some settings 
            //for product items images
            if((this.set_productItemGroup.product_item_group_is_color_image == 'IMG') && (this.set_productItemGroup.product_item_group_image != 'error')){
              this.set_productItem.product_item_image = this.set_productItemGroup.product_item_group_image;
            }else{ //is color or error
              this.set_productItem.product_item_image = '';
            }
            //for product_shipping_calculation_method
            this.set_productItem.product_shipping_calculation_method = this.set_productMain.product_set_shipping_fee_status;
            //../some settings 
    
            //some additional settings for cart circle to avoid mutation errors
            this.set_productItem.can_remove = true; //for removal when not selected for checkout at cart
            
            //cart sorting settings
            this.set_productItem.product_business_sort = this.set_productMain.product_business_ownername;
    
            //custom price settings
            // this.set_productItem.product_custom_set_price = 
            // this.set_productItem.product_custom_set_price_type =
    
            //agent settings
            this.set_productItem.product_referral_bash = "";
            this.set_productItem.product_has_referral_bash = 0;
            let product_ref = "REF-"+this.set_productMain.product_url_name;
            let ref_check = localStorage.getItem(product_ref);
            if(ref_check && ((ref_check != null) || (ref_check != ''))){
              this.set_productItem.product_has_referral_bash = 1;
              this.set_productItem.product_referral_bash = ref_check;
            }
            //check product referral
            // if(this.set_productMain.product_agent_ship.product_business_is_agent == 1){
            if(this.set_productMain.product_agent_ship && Object.keys(this.set_productMain.product_agent_ship).length > 0){
              if((this.set_productMain.product_agent_ship.product_business_is_agent) && (this.set_productMain.product_agent_ship.product_business_is_agent == 1)){
                this.set_productItem.product_is_from_agent = this.set_productMain.product_agent_ship.product_business_is_agent;
                this.set_productItem.product_business_agent_name = this.set_productMain.product_agent_ship.product_business_agent_name;
                this.set_productItem.product_business_agent_username = this.set_productMain.product_agent_ship.product_business_agent_username;
                this.set_productItem.product_business_sort = this.set_productMain.product_agent_ship.product_business_agent_username;
              }
            }
            //.../agent settings
            
            //service subscription update settings
            if(localStorage.getItem("product_sub")){
              let sub_check = localStorage.getItem("product_sub");
              if(sub_check && ((sub_check != null) || (sub_check != undefined) || (sub_check != ''))){
                this.set_productItem.product_is_updated_subscription = 1;
                this.set_productItem.product_current_subscription = sub_check;
              }
            }
    
            //product-order donate-to-buy, part-payments
            if(this.set_ctaType == 3){// part-payments
              this.set_productItem.product_order_part_payments_request = 1; //active
            }
            //../
            
            //prepare addon
            //---add addons to product if have
            if(this.set_productMain.selected_product_addons && (this.set_productMain.selected_product_addons.length > 0)){
              this.set_productItem.product_item_order_has_addon_orders = 1;
              this.set_productItem.product_order_addons  = this.set_productMain.selected_product_addons;
            }
            //---set product_added_on to if has
            if(this.set_productMain.product_order_addon_to && (this.set_productMain.product_order_addon_to > 0) ){
              this.set_productItem.product_item_order_is_add_on_to = this.set_productMain.product_order_addon_to;
            }
            //../addons
    
            //set buy-now-ref
            if(this.set_ctaType == 2){
              // this.set_productItem.product_buy_now_ref = 'qx-r'+this.set_productItem.product_item_id+this.set_productItem.product_url;
              this.set_productItem.product_buy_now_ref = 'qx-r'+this.set_productItem.product_item_id;
            }
    
            //
            this.$store.commit(ADD_TO_CART, this.set_productItem);
            
            //check if has selected addons
            if(this.set_productMain.selected_product_addons && (this.set_productMain.selected_product_addons.length > 0)){
              this.addProductAddonsToCart(this.set_productMain.selected_product_addons);
            }
            //./
    
            if(this.set_ctaType == 2){// buy-now
              //--set at localsorage
              localStorage.removeItem('bnrf');
              localStorage.setItem('bnrf',this.set_productItem.product_buy_now_ref);
              //....this.redir('order');//push to order
              //set order view
              this.set_xview = true;
            }
          },
    
         
          removeFromCart (payload) {
            this.$store.commit(REMOVE_FROM_CART, payload)
          },
    
  
          //add product addons to cart
          addProductAddonsToCart(selected_product_addons){
            //prepare their data to be added to cart
            // $ad_count = 0; 
            for(let product_addon of selected_product_addons){
              //set attributes needed
              this.set_ctaType = 1; //add to cart //default
              this.set_productMain = product_addon.productMain;
              this.set_productItemGroup = product_addon.productItemGroup; //as set during addon for add to cart
              this.set_productItem = product_addon.productItem;
              this.set_productMainView = '';
                
              //after setting call addtocart
              this.addToCart();
            }
          }

},
mounted:function(){
    // var top = document.getElementById("wrap").offsetTop; 
    // window.scrollTo(0, top); 
},
created: function(){
    
    this.setProduct();
    this.getStates();
    this.tab_view['descr'] = true;
},
destroyed () {
   // window.removeEventListener('scroll', this.handleScrollFix);
}
}


// WEBPACK FOOTER //
// ./src/components/order/Product/script.js